import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";
import {useState} from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {semanticColor, sizing} from "@khanacademy/wonder-blocks-tokens";
import {
    Body,
    BodyText,
    Heading,
    LabelSmall,
} from "@khanacademy/wonder-blocks-typography";

import {Section} from "../components/section/section.tsx";

import EmailSubscriptionCheckbox from "./email-subscription-switch.tsx";

interface Props {
    emailEnabled: boolean;
    subscriptionKey?: string;
    onChange: (emailEnabled: boolean) => unknown;
    footer?: React.ReactNode;
}

export const EmailGeneralSection: React.FC<Props> = ({
    emailEnabled,
    subscriptionKey,
    onChange,
    footer,
}) => {
    const [showError, setShowError] = useState(false);

    return (
        <Section
            legendContent={
                <View style={styles.legendContent}>
                    <Heading
                        tag="h2"
                        size="large"
                        weight="bold"
                    >{t`General`}</Heading>
                    <BodyText>
                        {t`Occasionally we'll send you email that we think you'll appreciate. Here, you can manage whether or not you receive those messages.`}
                    </BodyText>
                </View>
            }
            children={
                <View style={styles.container}>
                    <EmailSubscriptionCheckbox
                        checked={emailEnabled}
                        label={t`Receive email from Khan Academy`}
                        subscriptionKey={subscriptionKey}
                        showError={() => setShowError(true)}
                        clearError={() => setShowError(false)}
                        onChange={onChange}
                        inputId="enableEmail"
                    />

                    {(!subscriptionKey || showError) && (
                        <LabelSmall style={styles.errorText}>
                            {t`Oops! Something went wrong. Please try again.`}
                        </LabelSmall>
                    )}

                    {!emailEnabled && (
                        <Body style={styles.note}>
                            {t`Note that you may still receive critical email such as forgotten password resets.`}
                        </Body>
                    )}
                </View>
            }
            footer={footer}
        />
    );
};

const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: sizing.size_200,
    },
    errorText: {
        color: semanticColor.status.critical.foreground,
        marginBlockStart: sizing.size_040,
    },
    note: {
        marginBlockEnd: sizing.size_480, // Extra bottom margin to replace the xxLarge Strut
    },
    legendContent: {
        gap: sizing.size_160,
        marginBlockEnd: sizing.size_200,
    },
});

export default EmailGeneralSection;
